export class GenerateSqlQueryRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sqlEngineId",
            "baseName": "sqlEngineId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "prompt",
            "baseName": "prompt",
            "type": "string",
            "format": ""
        },
        {
            "name": "currentQuery",
            "baseName": "currentQuery",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GenerateSqlQueryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
